/**
 * «Вигляд» (M3, картка ScreenSettings): розмір тексту записів і формат часу.
 *
 * Теми тут немає: вона поки одна, світла ([ADR-0039]). Зʼявиться темна —
 * зʼявиться і рядок.
 *
 * Розмір масштабує лише текст записів і пунктів — через одну змінну
 * `--entry-scale`, яку читає `app.css`. Шапки й панель ростуть разом із
 * системним розміром шрифту телефону, а не з цим перемикачем.
 */
export const TEXT_STEPS = [14, 16, 17, 19, 22] as const;
export type TextStep = (typeof TEXT_STEPS)[number];

export type TimeFormat = "24" | "12";

const TEXT_KEY = "beresta:text-size";
const TIME_KEY = "beresta:time-format";

/** `localStorage` у приватному вікні кидає на доступі — розмір тексту не причина не відкритися. */
function read(key: string): string | null {
  try {
    return localStorage.getItem(key);
  } catch {
    return null;
  }
}

function write(key: string, value: string): void {
  try {
    localStorage.setItem(key, value);
  } catch {
    // Не збереглося — вибір діятиме до кінця сесії.
  }
}

export function textStep(): TextStep {
  const saved = Number(read(TEXT_KEY));
  return (TEXT_STEPS as readonly number[]).includes(saved) ? (saved as TextStep) : 17;
}

export function applyTextStep(step: TextStep = textStep()): void {
  globalThis.document?.documentElement.style.setProperty("--entry-scale", String(step / 17));
}

export function setTextStep(step: TextStep): void {
  write(TEXT_KEY, String(step));
  applyTextStep(step);
}

export function timeFormat(): TimeFormat {
  return read(TIME_KEY) === "12" ? "12" : "24";
}

export function setTimeFormat(format: TimeFormat): void {
  write(TIME_KEY, format);
}

/** Час за вибраним форматом: «14:30» або «2:30 PM». */
export function formatTime(at: number): string {
  return new Date(at).toLocaleTimeString(timeFormat() === "12" ? "en-US" : "uk-UA", {
    hour: timeFormat() === "12" ? "numeric" : "2-digit",
    minute: "2-digit",
  });
}
